<template>
  <v-content>
    <v-img :src="covers.length > 0 ? covers[0].eyecatch[0].original : ''" />
    <v-container>
      <div id="content">

        <section id="works" class="list">
          <h3>
            WORKS
            <v-btn text icon to="/mainte" v-if="admin">
              <v-icon color="secondary">fas fa-wrench</v-icon>
            </v-btn>
          </h3>
          <v-row>
            <v-col lg="3" md="4" sm="6" v-for="(item, key) in worksMap" :key="key">
              <v-card flat @click="worksView(item)">
                <v-img :src="getImage(item.eyecatch)" height="200px"></v-img>
                <v-card-text>
                  <div class="title">{{ item.title }}</div>
                  <div class="detail">{{ item.detail }}</div>
                  <div class="tags">
                    <ul class="list-inline">
                      <li v-for="tag in item.tags" :key="tag">
                        <v-chip small color="secondary" text-color="white">{{ tag }}</v-chip>
                      </li>
                    </ul>
                  </div>
                  <div class="date"><v-icon small>far fa-calendar-alt</v-icon>{{ getDate(item.date) }}</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </section>

        <section id="topics" class="list">
          <h3>
            TOPICS
            <v-btn text icon to="/mainte" v-if="admin">
              <v-icon color="secondary">fas fa-wrench</v-icon>
            </v-btn>
          </h3>
          <v-row>
            <v-col lg="3" md="4" sm="6" v-for="(item, key) in topicsMap" :key="key">
              <v-card flat @click="topicsView(item)">
                <v-img :src="getImage(item.eyecatch)" height="200px"></v-img>
                <v-card-text>
                  <div class="title">{{ item.title }}</div>
                  <div class="detail">{{ item.detail }}</div>
                  <div class="tags">
                    <ul class="list-inline">
                      <li v-for="tag in item.tags" :key="tag">
                        <v-chip small color="secondary" text-color="white">{{ tag }}</v-chip>
                      </li>
                    </ul>
                  </div>
                  <div class="date"><v-icon small>far fa-calendar-alt</v-icon>{{ getDate(item.date) }}</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </section>

        <section id="about">
          <h3>ABOUT</h3>
          <v-row align="center">
            <v-col justify="center" cols="12" sm="8">
              <p class="title font-weight-bold">「あったらいいな」をカタチに。</p>
              <p>Studio Piyoは「こんなのあったらいいな～」という思い付きから、気まぐれにモノづくりをしています。</p>
              <p>ユル～い感じでボチボチ続けていければと思っています。</p>
              <p>どうぞよろしくお願いいたします。</p>
            </v-col>
            <v-col justify="center" cols="12" sm="4">
              <v-img :src="require('@/assets/noimg.jpg')" />
            </v-col>
          </v-row>
        </section>

        <!-- worksダイアログ -->
        <v-dialog v-model="worksDialog" max-width="800px">
          <v-card class="dialog">
            <v-card-title class="dialog-header secondary--text">
              <span class="title font-weight-light">{{ work.title }}</span>
              <v-spacer></v-spacer>
              <v-btn text @click="worksDialog = false">
                <v-icon>clear</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col sm="4">
                  <v-img :src="getImage(work.eyecatch)" height="200px"></v-img>
                  <div class="tags">
                    <ul class="list-inline">
                      <li v-for="tag in work.tags" :key="tag">
                        <v-chip small color="secondary" text-color="white">{{ tag }}</v-chip>
                      </li>
                    </ul>
                  </div>
                </v-col>
                <v-col sm="8">
                  <div class="detail" v-html="convertDetail(work.detail)"></div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- topicsダイアログ -->
        <v-dialog v-model="topicDialog" max-width="800px">
          <v-card class="dialog">
            <v-card-title class="dialog-header secondary--text">
              <span class="title font-weight-light">{{ topic.title }}</span>
              <v-spacer></v-spacer>
              <v-btn text @click="topicDialog = false">
                <v-icon>clear</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col sm="4">
                  <v-img :src="getImage(topic.eyecatch)" height="200px"></v-img>
                  <div class="tags">
                    <ul class="list-inline">
                      <li v-for="tag in topic.tags" :key="tag">
                        <v-chip small color="secondary" text-color="white">{{ tag }}</v-chip>
                      </li>
                    </ul>
                  </div>
                </v-col>
                <v-col sm="8">
                  <div class="detail" v-html="convertDetail(topic.detail)"></div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </v-container>
  </v-content>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'

export default {
  data() {
    return {
      covers: [],
      works: [],
      work: {},
      worksDialog: false,
      topics: [],
      topic: {},
      topicDialog: false
    }
  },
  components: {

  },
  computed: {
    coverImage() {
      const cover = this.covers[Math.floor(Math.random() * this.covers.length)]
      return cover ? cover.eyecatch[0].original : ''
    },
    worksMap() {
      const map = []
      this.works.forEach(e => map.push(
        Object.assign({}, e)
      ))
      return map.reverse()
    },
    topicsMap() {
      const map = []
      this.topics.forEach(e => map.push(
        Object.assign({}, e)
      ))
      return map.reverse()
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      let path = this
      firebase.database().ref('posts/covers').orderByChild('date').limitToLast(1).on('child_added', function(data) {
        path.covers.push(Object.assign({
          id: data.key,
        }, data.val()))
      })
      firebase.database().ref('posts/works').orderByChild('date').limitToLast(12).on('child_added', function(data) {
        path.works.push(Object.assign({
          id: data.key,
        }, data.val()))
      })
      firebase.database().ref('posts/topics').orderByChild('date').limitToLast(4).on('child_added', function(data) {
        path.topics.push(Object.assign({
          id: data.key,
        }, data.val()))
      })
    },
    worksView(item) {
      this.work = Object.assign({}, item)
      this.worksDialog = true
    },
    topicsView(item) {
      this.topic = Object.assign({}, item)
      this.topicDialog = true
    },
    convertDetail(str) {
      var urlExp = /(https?:\/\/[\x21-\x7e]+)/g
      return String(str).replace(urlExp, '<a href="$1" target="_blank">$1</a>')
    }
  }
}
</script>

<style lang="scss" scoped>
section.list {
  .title {
    font-size: 16px !important;
    font-weight: bold;
  }
  .detail {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    font-weight: 600;
  }
  .date {
    text-align: right;
    i {
      vertical-align: baseline;
      margin-right: 5px;
    }
  }
}
ul.list-inline {
  margin: 0;
  padding: 0;
  list-style: none;
  > li {
    display: inline-block;
    width: auto;
    padding: 5px 0;
  }
}
.dialog {
  .title {
    font-weight: 600 !important;
  }
  .detail {
    white-space: pre-wrap;
    font-weight: 600;
  }
}
.VueCarousel-slide {
  img {
    object-fit: cover;
    object-position: center;
    width: 100%;
    height: 300px;
  }
}
</style>
